import { useContext } from 'react';
import { useFoundersContext } from '../../contexts/founders-context';
import { UserContext } from '../../contexts/user-context';
import ConfirmModal from '../common/confirm-modal';

function FounderProfileUpdateModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isSendingProfileUpdate,
    profileUpdateTargetFounderId,
    setProfileUpdateTargetFounderId,
    sendFounderUpdateProfilesTarget,
  } = useFoundersContext();

  return hasAccessToAction('founder.updateProfile') ? (
    <ConfirmModal
      isOpen={!!profileUpdateTargetFounderId}
      onClose={() => setProfileUpdateTargetFounderId(null)}
      title='Send Single Profile Update Request'
      loading={isSendingProfileUpdate}
      body='Your are about to send a temporary link to allow participants to update their profile. The link can work only 1 time, and is available for 48 hours only.'
      successProps={{
        btnLabel: 'Ok',
        onSuccess: sendFounderUpdateProfilesTarget,
      }}
      cancelProps={{
        btnLabel: 'Cancel',
      }}
    />
  ) : null;
}

export default FounderProfileUpdateModal;
